import React from 'react';
import { Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-dark text-white text-center py-3 mt-auto">
      <Container>
        <p className="mb-1">
          © {new Date().getFullYear()} Evazard es un producto de CValenciaIT. Desarrollado por Jesús Antonio Castañeda Valencia.
        </p>
        <p className="mb-1">
          <Link to="/terms-of-service" target="_blank" rel="noopener noreferrer" className="text-white mx-2">
            Términos y Condiciones
          </Link>
          |
          <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-white mx-2">
            Política de Privacidad
          </Link>
        </p>
        <p className="mb-0">
          Contacto: cvalenciait.contacto@gmail.com
        </p>
      </Container>
    </footer>
  );
};

export default Footer;